import AGREGAR_PROYECTO_DOCUMENTO_TIPO from '@/graphql/mutations/administracion/control-proyectos/documentos-tipos/agregarProyectoDocumentoTipo.gql';
import ACTUALIZAR_PROYECTO_DOCUMENTO_TIPO from '@/graphql/mutations/administracion/control-proyectos/documentos-tipos/actualizarProyectoDocumentoTipo.gql';
import REMOVER_PROYECTO_DOCUMENTO_TIPO from '@/graphql/mutations/administracion/control-proyectos/documentos-tipos/removerProyectoDocumentoTipo.gql';
import PROYECTOS_DOCUMENTOS_TIPOS from '@/graphql/querys/administracion/control-proyectos/documentos-tipos/proyectosDocumentosTipos.gql';

export default {
  methods: {
    async mixAgregarProyectoDocumentoTipo() {
      // Agregar Proyecto Documento Tipo
      this.mixEsCargando();
      this.enviandoFormulario = true;

      await this.$apollo
        .mutate({
          mutation: AGREGAR_PROYECTO_DOCUMENTO_TIPO,
          variables: {
            documentoTipo: this.documentoTipo,
          },
          update: (store, { data: { agregarProyectoDocumentoTipo } }) => {
            const query = {
              query: PROYECTOS_DOCUMENTOS_TIPOS,
            };
            const { proyectosDocumentosTipos } = store.readQuery(query);
            const proyectosDocumentosTiposCopia = proyectosDocumentosTipos.slice();
            proyectosDocumentosTiposCopia.push(agregarProyectoDocumentoTipo);
            store.writeQuery({
              ...query,
              data: {
                proyectosDocumentosTipos: proyectosDocumentosTiposCopia,
              },
            });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    // Editar Proyecto Documento Tipo
    async mixActualizarProyectoDocumentoTipo() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo
        .mutate({
          mutation: ACTUALIZAR_PROYECTO_DOCUMENTO_TIPO,
          variables: {
            id: this.proyectoDocumentoTipoEditar.id,
            documentoTipo: this.documentoTipo,
          },
          update: (store, { data: { actualizarProyectoDocumentoTipo } }) => {
            const query = {
              query: PROYECTOS_DOCUMENTOS_TIPOS,
            };
            const data = store.readQuery(query);
            const { proyectosDocumentosTipos } = data;
            const index = proyectosDocumentosTipos
              .findIndex((proyectosDocumentosTipo) => proyectosDocumentosTipo.id
              === actualizarProyectoDocumentoTipo.id);
            if (index !== -1) {
              proyectosDocumentosTipos.splice(index, 1, actualizarProyectoDocumentoTipo);
            }
            store.writeQuery({ ...query, data });
          },
        }).then(() => {
          this.mixMensajeSuccess();
        }).catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    // Eliminar Proyecto Documento Tipo
    async mixEliminarProyectoDocumentoTipo() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: REMOVER_PROYECTO_DOCUMENTO_TIPO,
        variables: {
          id: this.proyectoDocumentoTipoEliminar.id,
        },
        update: (store) => {
          const query = {
            query: PROYECTOS_DOCUMENTOS_TIPOS,
          };
          const data = store.readQuery(query);
          const { proyectosDocumentosTipos } = data;
          const index = proyectosDocumentosTipos
            .findIndex((proyectosDocumentosTipo) => proyectosDocumentosTipo.id
            === this.proyectoDocumentoTipoEliminar.id);
          if (index !== -1) {
            proyectosDocumentosTipos.splice(index, 1);
          }
          store.writeQuery({ ...query, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
  },
};
